// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._154i1ssb{top:50%}\n._154iidpf{top:0}\n._1ltv1ssb{left:50%}\n._1ltvidpf{left:0}\n._1pby1qpw{z-index:520}\n._1xi2idpf{right:0}\n._94n5idpf{bottom:0}\n._kqsw1n9t{position:fixed}\n._kqswstnw{position:absolute}\n._t9ec1ooe{transform:translate(-50%,-50%)}", ""]);
// Exports
module.exports = exports;
